import { FC, useRef } from 'react';

import { getFormattedIntNumber } from 'utils/clickme';

import { Text, TooltipHover } from '@hh.ru/magritte-ui';
import { CheckCircleFilledSize24, ExclamationCircleFilledSize24 } from '@hh.ru/magritte-ui/icon';

import useTrls from 'hooks/translation/useTrls';

import { selectAudienceReach, TrafficLightStatus } from 'store/models/predictWindow';
import { useSelector } from 'store/utils';

import styles from 'components/CpcFlexibleCreate/PredictWindow/TrafficLight/TrafficLight.module.less';

const TRAFFIC_LIGHT_STATUS = {
    [TrafficLightStatus.Narrow]: <ExclamationCircleFilledSize24 initialColor="negative" />,
    [TrafficLightStatus.Medium]: <ExclamationCircleFilledSize24 initialColor="warning" />,
    [TrafficLightStatus.Wide]: <CheckCircleFilledSize24 initialColor="positive" />,
    [TrafficLightStatus.Disabled]: null,
};

const TrlKeys = {
    [TrafficLightStatus.Narrow]: 'AdCreate.AdForm.PredictWindow.TrafficLight.tooltipNarrow',
    [TrafficLightStatus.Medium]: 'AdCreate.AdForm.PredictWindow.TrafficLight.tooltipMedium',
    [TrafficLightStatus.Wide]: 'AdCreate.AdForm.PredictWindow.TrafficLight.tooltipWide',
    [TrafficLightStatus.Disabled]: null,
};

const DATA_QA_BY_STATUS = {
    [TrafficLightStatus.Narrow]: 'ready',
    [TrafficLightStatus.Medium]: 'steady',
    [TrafficLightStatus.Wide]: 'go',
    [TrafficLightStatus.Disabled]: 'disabled',
};

export const TrafficLight: FC<{ status: TrafficLightStatus }> = ({ status }) => {
    const predictedAudienceReach = useSelector(selectAudienceReach) ?? 0;

    const trl = useTrls();

    const activatorRef = useRef<HTMLDivElement>(null);

    return (
        <div className={styles.wrapper} data-qa={DATA_QA_BY_STATUS[status]}>
            <Text typography="title-3-semibold" data-qa="predicted-audience-reach">
                {getFormattedIntNumber(predictedAudienceReach)}
            </Text>
            <div ref={activatorRef}>{TRAFFIC_LIGHT_STATUS[status]}</div>
            <TooltipHover activatorRef={activatorRef} placement="top-center">
                <Text>{trl(TrlKeys[status])}</Text>
            </TooltipHover>
        </div>
    );
};
